import React from 'react';
import loader from 'src/components/LoaderImg/loader.gif';

type Props = {};

function CommonLoader({}: Props) {
  return (
    <img
      src={loader}
      alt="loader"
      style={{
        width: '150px',
        margin: 'auto',
        alignContent: 'center',
        marginTop: '10%',
        display: 'block',
      }}
    />
  );
}

export default CommonLoader;
